//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
export default {
  components: { work_bench_item },
  data() {
    return {
      actionTitle:'',
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: '选择入库方式',
        actions: [
          { name: '基于订单入库', url: 'http://ysl.entfly.com/mSms/ShopStockInByDealerOutOrder/Index' },
          { name: '采购入库', url: 'http://ysl.entfly.com/Sms/ShopStockInBuyOrder/Scan' },
        ],
      },
      actionSheet2: {
        title: '选择出库方式',
        actions: [
          { name: '1.销售出库[帮积分]', url:'http://ysl.entfly.com/mSms/PrizeStockOutProductOrder/Check' },
          { name: '2.销售出库[无积分]', url:'http://ysl.entfly.com/Sms/ShopStockOutSalesOrder/SetTo?from=/mSms/RbnWorkbench/Index?uOpenId=8659662804444e4b9ff929bb78b3da21?tab=1' },
          { name: '3.退货出库', url:'http://ysl.entfly.com/mSms/ShopStockOutReturnOrder/SetTo?from=/mSms/RbnWorkbench/Index?uOpenId=8659662804444e4b9ff929bb78b3da21?tab=1' },
        ],
      },
      actionSheet3: {
        title: '选择核销方式',
        actions: [
          { name: '扫码核销', callback: function () { console.log('调用微信扫码接口') } },
          { name: '查看核销记录', url:'http://ysl.entfly.com/mMis/MemberCouponOrder/Index' },
        ],
      },
      actionSheet4: {
        title: '选择兑换方式',
        actions: [
          { name: '1.地址邮寄', url: 'http://ysl.entfly.com/mSms/MemberPointsOutExchangeOrder/Check' },
          { name: '2.门店自提', url:'http://ysl.entfly.com/mSms/MemberPointsOutExchangeOrderForShop/Check' },
        ],
      },

      work_bench_item1: [
        {
          img: "images/1_15.png",
          text: "我要入库",
          action: 'checkin'
        },
        {
          img: "images/1_19.png",
          text: "我要出库",
          action: 'checkout'
        },
        {
          img: "images/1_23.png",
          text: "我要盘点",
          link: this.$api.host+"/Sms/ShopStockCheckOrder/Scan",
          hide_border: true
        },
     
      ],
      work_bench_item2: [
        {
          img: "images/3_06.png",
          text: "帮积分",
          link: this.$api.host+"/mSms/PrizeStockOutProductOrder/Check3"
        },
        {
          img: "images/n_03.png",
          text: "帮兑换",
          action: 'helpExchange'
        },
        {
          img: "images/3_08.png",
          text: "帮注册",
          link: this.$api.host+"/mSms/Member/Register",
          hide_border: true
        },
      ],
      work_bench_item3: [
        {
          img: "images/20_07.png",
          text: "积分核销",
          link: this.$api.host+"/mSms/PrizeStockOutProductOrder/Index",
        },
        {
          img: "images/2_10.png",
          text: "优惠券核销",
          hide_border: true,
          action: 'checkCoupon'
        },
      ],
      work_bench_item4: [
        {
          img: "images/20_14.png",
          text: "门店会员",
          link: this.$api.host+"/mSms/Member/Index?from=home",
        },
        {
          img: "images/1_32.png",
          text: "公告信息",
          link: this.$api.host+"/mSms/ShopNotice/Index",
          hide_border: true
        }
      ],
      work_bench_item5: [
        {
          img: "images/31_07.png",
          text: "我的钱包",
          link: this.$api.host+"/mCc/ShopCashInOrder/Index",
        },
        {
          img: "images/31_11.png",
          text: "钱包记录",
          link: this.$api.host+"/mCc/PassageUserCashDataLog/Index",
          hide_border: true
        },
        {
          img: "images/31_07.png",
          text: "我的积分",
          link: "/mSms/PassageUserPointsData",
        },
        {
          img: "images/31_11.png",
          text: "积分记录",
          link: "/mSms/pointsHistoryOne",
        },
      ],
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },

  created () {
    this.$wxConfig()
    this.$store.dispatch('get_passageUserInfo')
  },

  methods: {
    goGuideRightsPage () {
      this.$router.push('/mGms/guideRights')
    },
    goPage (link) {
      if (link) {
        if (link.indexOf('http') == -1) {
          this.$router.push(link)
        } else {
          window.location = link
          this.$msg.loading()
        }
      }
    },
    checkin () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet1.title
      this.actionList = this.actionSheet1.actions
    },
    checkout () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet2.title
      this.actionList = this.actionSheet2.actions
    },
    checkCoupon () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet3.title
      this.actionList = this.actionSheet3.actions
    },
    helpExchange () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet4.title
      this.actionList = this.actionSheet4.actions
    },
    onSelect (item) {
      console.log(item)
      if (item.url) {
        if (item.url.indexOf('http') == -1) {
          this.$router.push(item.url)
        } else {
          window.location = item.url
          this.$msg.loading()
        }
      }
    },
    onClickScanBtn () {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log('扫码成功', res1)
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
